module.exports = __webpack_public_path__ + "static/img/pay_for_success_img.a7e8876.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pay_for_success_img.png
// module id = OFVg
// module chunks = 1